import * as React from 'react';
import { Button, Group, Modal, TextInput, PasswordInput } from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import axios from 'axios';
import { IResponse } from "../../types/api";
import { showMessage } from "../../lib/notification";
import { IconAt } from "@tabler/icons-react";
import styles from './login.module.scss';

interface IForgotPasswordProps {
    onClose: () => void;
}

interface IOTPResponse {
    expirationDuration: number;
    message: string;
    otp: number;
    resendDuration: number;
    verificationToken: string;
}

type FormType = 'email' | 'password';

const labelProps = {
    style: {
        fontWeight: 500,
        fontSize: 14
    }
}

const ForgotPassword = ({
    onClose
}: IForgotPasswordProps) => {

    const [ email, setEmail ] = React.useState<string | null>( null);
    const [ verificationToken, setVerificationToken ] = React.useState<string | null>( null);
    const [ formType, setFormType ] = React.useState<FormType>('email');
    const [ message, setMessage ] = React.useState('');

    const form = useForm({
        initialValues: {
            email: '',
        },
        validate: {
            email: isNotEmpty('И-Мэйл хаяг оруулна уу'),
        }
    });

    const changePWForm = useForm({
        initialValues: {
            otp: '',
            password: '',
            repeat: '',
        },
        validate: {
            otp: isNotEmpty('Баталгаажуулах код оруулна уу'),
            password: isNotEmpty('Нууц үг оруулна уу'),
            repeat: (value, values) => value !== values.password ? 'Нууц үг тохирохгүй байна' : null,
        }
    })

    const handleSubmit = async (values: typeof form.values) => {
        const { data } = await axios.post<IResponse<IOTPResponse>>('/auth/forgot-password', values);
        if (data.result.verificationToken) {
            setVerificationToken(data.result.verificationToken);
            setEmail(values.email);
            setFormType('password');
            setMessage(data.result.message);
        }
    }

    const changePassword = async (values: typeof changePWForm.values) => {
        const params = {
            email,
            password: values.password,
            otp: values.otp,
            verificationToken
        }
        const { data } = await axios.post('/auth/change-password', params);
        if (data.status === 'OK') {
            showMessage(data.result ?? 'Амжилттай', 'green');
            onClose();
        }
    }

    return (
        <Modal
            opened={true}
            onClose={onClose}
            title={'Нууц үг сэргээх'}
        >
            {
                formType === 'email'
                ?   <form onSubmit={form.onSubmit(handleSubmit)} style={{ marginTop: '3rem' }} >
                        <TextInput
                            label={'И-Мэйл'}
                            my={'xl'}
                            autoComplete={'off'}
                            placeholder='email@example.com'
                            style={{ marginBottom: '1rem' }}
                            labelProps={labelProps}
                            icon={<IconAt size={18}/>}
                            {...form.getInputProps('email')}
                        />
                        <Group position='right'>
                            <Button type="submit" mt={40} mb={10} color={'color-primary'}>Нууц үг сэргээх код авах</Button>
                        </Group>
                    </form>
                :   <form onSubmit={changePWForm.onSubmit(changePassword)}>
                        <div className={styles.message}>
                            {message}
                        </div>
                        <TextInput
                            label={'Баталгаажуулах код'}
                            autoComplete={'off'}
                            labelProps={labelProps}
                            {...changePWForm.getInputProps('otp')}
                        />
                        <PasswordInput
                            label={'Шинэ нууц үг'}
                            autoComplete={'off'}
                            labelProps={labelProps}
                            {...changePWForm.getInputProps('password')}
                        />
                        <PasswordInput
                            label={'Шинэ нууц үг давтах'}
                            autoComplete={'off'}
                            labelProps={labelProps}
                            {...changePWForm.getInputProps('repeat')}
                        />
                        <Group position='right'>
                            <Button type="submit" mt={40} mb={10} color={'color-primary'}>Нууц үг солих</Button>
                        </Group>
                    </form>
            }
        </Modal>
    )
};

export default ForgotPassword;